import { DataRow } from '@/types';
import data from './raw-data.json';
export default data as DataRow[];
